export default __webpack_public_path__ + "static/media/Clear_Icon_New.9227f44d.svg";